<template>
  <div>
    <div class="py-2">
      <span><strong>Month/Hour Heatmap Usage</strong></span>
      <div class="text-sm">
        <p>
          This heatmap shows average energy intensity across each month of the
          year, broken down into hourly consumption. This is useful at
          highlighting any seasonality in your energy profile and the energy
          impact of your operation at different times of the year.
        </p>
      </div>
    </div>
    <VueApexCharts
      :options="heatmapMonthTrendChart.options"
      :series="props.seriesData"
      height="350px"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { defineProps, toRaw, computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => [],
  },
});

const maxValue = computed(() => {
  let check = [];
  toRaw(props.seriesData).forEach((item) => {
    check.push(...item.data);
  });
  const max = Math.max(...check.map((i) => i.y));
  return max;
});

const minValue = computed(() => {
  let check = [];
  toRaw(props.seriesData).forEach((item) => {
    check.push(...item.data);
  });
  const min = Math.min(...check.map((i) => i.y));
  return min;
});

// * Heatmap Trend data
const heatmapMonthTrendChart = computed(() => {
  return {
    options: {
      chart: {
        toolbar: {
          show: true,
        },
        type: "heatmap",
      },
      plotOptions: {
        heatmap: {
          shadeIntensity: 0.6,
          radius: 5,
          colorScale: {
            ranges: [
              {
                from: minValue.value,
                to: minValue.value + 1,
                name: "Usage",
                color: "#2B978D",
              },
              {
                from: minValue.value + 1,
                to: maxValue.value - 1,
                name: "Usage",
                color: "#0C1E36",
              },
              {
                from: maxValue.value,
                to: maxValue.value + 1,
                name: "Usage",
                color: "#FD6213",
              },
            ],
          },
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        width: 2,
      },
    },
  };
});
</script>
